import { render } from "./prefab-edit.vue?vue&type=template&id=603dc915"
import script from "./prefab-edit.vue?vue&type=script&lang=js"
export * from "./prefab-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__